import { Component, inject, signal } from '@angular/core';
import { FormField, form, minLength, required } from '@angular/forms/signals';


import { CautareService } from '../../shared/services/cautare.service';
import { MatCard, MatCardTitle, MatCardContent, MatCardActions } from '@angular/material/card';
import { MatFormField, MatLabel, MatInput, MatSuffix, MatHint } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { JudetPipe } from '../../shared/pipes/judet.pipe';
import { CautareStore } from '../../shared/state/cautare.store';
import { UiStore } from '../../shared/state/ui.store';
import { MedicNavigare } from '../../shared/services/medic-navigare.service';

@Component({
    selector: 'app-cautare',
    templateUrl: './cautare.component.html',
    styleUrls: ['./cautare.component.scss'],
    imports: [MatCard, MatCardTitle, MatCardContent, FormField, MatFormField, MatLabel, MatInput, MatIcon, MatSuffix, MatHint, MatCardActions, MatButton, JudetPipe]
})
export class CautareComponent {
  private readonly medicNavigare = inject(MedicNavigare);
  private readonly cautareStore = inject(CautareStore);
  private readonly uiStore = inject(UiStore);
  private cautareMedic = inject(CautareService);

  // doua cautari independente: registrul CMJ-ului si registrul national
  private readonly cautareCMJ = signal('');
  private readonly cautareCMR = signal('');
  protected readonly searchFormCMJ = form(this.cautareCMJ, p => {
    required(p);
    minLength(p, 3);
  });
  protected readonly searchFormCMR = form(this.cautareCMR, p => {
    required(p);
    minLength(p, 3);
  });
  protected readonly user = this.uiStore.user;
  protected readonly isLoading = this.uiStore.isLoading;

  onSearch(searchVal: string, searchType: string) {
    if ((this.searchFormCMJ().valid() || this.searchFormCMR().valid()) && !this.isLoading()) {
      this.cautareMedic.cautaMedic(searchVal, searchType);
    }
    switch (searchType) {
      case 'cmj':
        this.cautareStore.clearListaCmr();
        this.cautareCMR.set('');
        break;
      case 'cmr':
        this.cautareStore.clearListaCmj();
        this.cautareCMJ.set('');
        break;
      default:
        break;
    }

  }

  clearSearch(item: string) {
    switch (item) {
      case 'cmj':
        this.cautareStore.clearListaCmj();
        this.cautareCMJ.set('');
        return;
      case 'cmr':
        this.cautareStore.clearListaCmr();
        this.cautareCMR.set('');
        return;

      default:
        break;
    }
  }

  medicNou() {
    this.medicNavigare.nou();
  }
}
